import { useWindowStore } from '@/stores/windowStore';
import { getAppById } from '@/config/desktopApps';
import { Window } from './Window';

export function WindowManager() {
  const { windows, getActiveWindow } = useWindowStore();
  const activeWindow = getActiveWindow();

  return (
    <>
      {windows.map((window) => {
        const app = getAppById(window.appId);
        if (!app) return null;

        return (
          <Window
            key={window.id}
            window={window}
            app={app}
            isActive={activeWindow?.id === window.id}
          />
        );
      })}
    </>
  );
}
